export const OTHER_LOCALISATION_STRING = 'other';
